import axios from '../modules/axios';

export default {
	namespaced: true,
	state: {
		open: false,
		data: window.shop.cart
	},
	mutations: {
		data(state, data) {
			state.data = data;
		},
		open(state, open) {
			state.open = open;
		}
	},
	actions: {
		async getData({commit}) {
			const {data} = await axios.get(`/cart.js?cache=${Date.now()}`, {
				headers: {
					Pragma: 'no-cache'
				}
			});
			commit('data', data);
		},
		async add({dispatch, commit}, data) {
			function getQueryString(data = {}) {
				return Object.entries(data)
					.map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
					.join('&');
			}
			await axios.post('/cart/add.js', data, {
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				},
				transformRequest: getQueryString
			});

			await dispatch('getData');
			commit('open', true);
		},
		async change({dispatch}, {id, quantity}) {
			await axios.post('/cart/update.js', {
				updates: {
					[id.toString()]: quantity
				}}).catch(function (error) {
        console.log(error.toJSON());
      });
				await dispatch('getData');
		}
	},
	getters: {
		data(state) {
			return state.data;
		},
		open(state) {
			return state.open;
		}
	}
}
